export const SELECT_CATEGORIAS_PRODUCTOS = [
  "Archivo y Organización", 
  "Sacapuntas",
  "Engrapado",
  "Pélicula autoadherible para forrar",
  "Reglas y juegos de geometría",
  "Calculadoras",
  "Corte",
  "Escritura",
  "Tijeras escolares",
  "Pegamentos y silicón",
  "Correctores",
  "Pinturas y accesorios",
  "Gomas",
  "Tijeras multiusos",
  "Manualidades",
  "Clips y accesorios de escritorio",
  "Artículos de oficina",
  "Cubiertas para engargolar",
  "Didáctico",
  "Micas térmicas",
  "Pizarrónes",
  "Protectores de hojas",
  "Cuaderno",
  "Agenda"
]


export const CATEGORIAS_DESCARGABLES = ['Creatividad', 'Coleccionables', 'Inspiración', 'Recursos Educativos', 'Fandom'];

export const LABELS_DESCARGABLES = ['Descargable', 'Descargables', 'Descarga plantilla', 'Descarga manual', 'Descarga garantía', 'Descarga manual y garantía'];